import type { merchantsAPI } from '@backmarket/http-api'

export function toOption(category: merchantsAPI.DocWebsiteCategory) {
  return {
    id: category.categoryId.toString(),
    label: category.categoryName,
    value: category.categoryId.toString(),
  }
}
